<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
  }
}
</script>

<template>
  <v-row>
    <v-col class="text-center">
      <h2>{{ title }}</h2>
      <p>{{ subtitle }}</p>
    </v-col>
  </v-row>
</template>
